/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

/* Document
   ========================================================================== */

/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */

html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/* Sections
     ========================================================================== */

/**
   * Remove the margin in all browsers.
   */

body {
  margin: 0;
}

/**
   * Render the `main` element consistently in IE.
   */

main {
  display: block;
}

/**
   * Correct the font size and margin on `h1` elements within `section` and
   * `article` contexts in Chrome, Firefox, and Safari.
   */

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
     ========================================================================== */

/**
   * 1. Add the correct box sizing in Firefox.
   * 2. Show the overflow in Edge and IE.
   */

hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd `em` font sizing in all browsers.
   */

pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/* Text-level semantics
     ========================================================================== */

/**
   * Remove the gray background on active links in IE 10.
   */

a {
  background-color: transparent;
}

/**
   * 1. Remove the bottom border in Chrome 57-
   * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
   */

abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted; /* 2 */
}

/**
   * Add the correct font weight in Chrome, Edge, and Safari.
   */

b,
strong {
  font-weight: bolder;
}

/**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd `em` font sizing in all browsers.
   */

code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
   * Add the correct font size in all browsers.
   */

small {
  font-size: 80%;
}

/**
   * Prevent `sub` and `sup` elements from affecting the line height in
   * all browsers.
   */

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
     ========================================================================== */

/**
   * Remove the border on images inside links in IE 10.
   */

img {
  border-style: none;
}

/* Forms
     ========================================================================== */

/**
   * 1. Change the font styles in all browsers.
   * 2. Remove the margin in Firefox and Safari.
   */

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
   * Show the overflow in IE.
   * 1. Show the overflow in Edge.
   */

button,
input {
  /* 1 */
  overflow: visible;
}

/**
   * Remove the inheritance of text transform in Edge, Firefox, and IE.
   * 1. Remove the inheritance of text transform in Firefox.
   */

button,
select {
  /* 1 */
  text-transform: none;
}

/**
   * Correct the inability to style clickable types in iOS and Safari.
   */

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

/**
   * Remove the inner border and padding in Firefox.
   */

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
   * Restore the focus styles unset by the previous rule.
   */

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
   * Correct the padding in Firefox.
   */

fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
   * 1. Correct the text wrapping in Edge and IE.
   * 2. Correct the color inheritance from `fieldset` elements in IE.
   * 3. Remove the padding so developers are not caught out when they zero out
   *    `fieldset` elements in all browsers.
   */

legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
   * Add the correct vertical alignment in Chrome, Firefox, and Opera.
   */

progress {
  vertical-align: baseline;
}

/**
   * Remove the default vertical scrollbar in IE 10+.
   */

textarea {
  overflow: auto;
}

/**
   * 1. Add the correct box sizing in IE 10.
   * 2. Remove the padding in IE 10.
   */

[type="checkbox"],
[type="radio"] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
   * Correct the cursor style of increment and decrement buttons in Chrome.
   */

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

/**
   * 1. Correct the odd appearance in Chrome and Safari.
   * 2. Correct the outline style in Safari.
   */

[type="search"] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
   * Remove the inner padding in Chrome and Safari on macOS.
   */

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
   * 1. Correct the inability to style clickable types in iOS and Safari.
   * 2. Change font properties to `inherit` in Safari.
   */

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/* Interactive
     ========================================================================== */

/*
   * Add the correct display in Edge, IE 10+, and Firefox.
   */

details {
  display: block;
}

/*
   * Add the correct display in all browsers.
   */

summary {
  display: list-item;
}

/* Misc
     ========================================================================== */

/**
   * Add the correct display in IE 10+.
   */

template {
  display: none;
}

/**
   * Add the correct display in IE 10.
   */

[hidden] {
  display: none;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font-style: inherit;
  vertical-align: baseline;
}


a {
  text-align: center;
}

.item-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(var(--ic-space-xl) + var(--ic-space-sm));
  height: var(--ic-space-xl);
  margin: var(--ic-space-xxs) var(--ic-space-xxxs);
  cursor: pointer;
  text-decoration: none;
}

button {
  background: none;
  border: none;
  outline: inherit;
  position: relative;
}

.ellipsis {
  pointer-events: none;

  --ic-typography-color: var(--ic-pagination-ellipsis);
}

.monochrome .ellipsis {
  --ic-typography-color: var(--ic-pagination-ellipsis-monochrome);
}

.item-container:focus {
  box-shadow: var(--ic-border-focus);
  outline: var(--ic-hc-focus-outline);
  border-radius: var(--ic-border-radius);
  transition: var(--ic-easing-transition-fast);
}

.page {
  --ic-typography-color: var(--ic-pagination-page-number);
}

.monochrome .page {
  --ic-typography-color: var(--ic-pagination-page-number-monochrome);
}

.simple-current {
  min-width: calc(var(--ic-space-xxl));
  padding: 0 var(--ic-space-xs);
  height: var(--ic-space-lg);
  cursor: default;
}

/** DEFAULT STATES **/
.item-container.page:hover:not(.selected):not(:focus) {
  border-radius: var(--ic-border-radius);
  background-color: var(--ic-pagination-hover);
}

.item-container.page:active:not(.selected):not(:focus) {
  background-color: var(--ic-pagination-pressed);
}

.monochrome .item-container.page:hover:not(.selected):not(:focus) {
  background-color: var(--ic-pagination-hover-monochrome);
}

.monochrome .item-container.page:active:not(.selected):not(:focus) {
  background-color: var(--ic-pagination-pressed-monochrome);
}

.selected {
  pointer-events: none;
  outline: none;
}

.selected::after {
  content: "";
  height: var(--ic-space-xxs);
  width: 100%;
  position: absolute;
  bottom: 0;
  background-color: var(--ic-pagination-selected-banner);
}

.monochrome .selected::after {
  background-color: var(--ic-pagination-selected-banner-monochrome);
}

.page-selected {
  --ic-typography-color: var(--ic-pagination-text);
}

/** LIGHT STATES **/
.item-container.page.light:hover:not(.selected):not(:focus) {
  background-color: var(--ic-action-light-bg-hover);
}

.item-container.page.light:active:not(.selected):not(:focus) {
  background-color: var(--ic-action-light-bg-pressed);
}

ic-typography.light,
ic-typography.page-selected.light {
  --ic-typography-color: var(--ic-architectural-white);
}

.selected.light::after {
  content: "";
  height: var(--ic-space-xxs);
  width: 100%;
  position: absolute;
  bottom: 0;
  background-color: var(--ic-action-monochrome);
}

/** DARK STATES **/
.item-container.page.dark:hover:not(.selected):not(:focus) {
  background-color: var(--ic-action-dark-bg-hover);
}

.item-container.page.dark:active:not(.selected):not(:focus) {
  background-color: var(--ic-action-dark-bg-pressed);
}

ic-typography.dark {
  --ic-typography-color: var(--ic-color-text-primary);
}

.selected.dark::after {
  content: "";
  height: var(--ic-space-xxs);
  width: 100%;
  position: absolute;
  bottom: 0;
  background-color: var(--ic-action-monochrome-dark);
}

.disabled {
  --ic-typography-color: var(--ic-pagination-text-disabled);

  pointer-events: none;
  cursor: none;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.disabled.page ic-typography {
  --ic-typography-color: var(--ic-pagination-page-number-disabled);
}

.disabled.ellipsis {
  --ic-typography-color: var(--ic-pagination-ellipsis-disabled);
}

.monochrome .disabled.page {
  --ic-typography-color: var(--ic-pagination-page-number-monochrome-disabled);
}

.monochrome .disabled.ellipsis {
  --ic-typography-color: var(--ic-pagination-ellipsis-monochrome-disabled);
}

@media (forced-colors: active) {
  .selected::after {
    background-color: Highlight;
  }

  .selected.light::after {
    background-color: Highlight;
  }

  .selected.dark::after {
    background-color: Highlight;
  }

  .disabled {
    --ic-typography-color: GrayText;
  }
}

@media (prefers-reduced-motion: reduce) {
  .item-container:focus {
    transition: none;
  }
}
